<template>
  <div
    class="w-full lg:max-w-3xl flex justify-center items-center px-5 py-3 shadow border border-base-300 rounded-xl"
  >
    <div class="flex flex-col">
      <ConfigModifiedIndicator
        class="animate-pulse hover:animate-none pl-1 pr-4"
      />
      <ConfigWarnings indicatorClass="pl-1 pr-4" />
    </div>

    <div
      class="w-full flex flex-row flex-wrap md:flex-nowrap justify-center items-center gap-3"
    >
      <ConfigList class="tour-config-list w-full mr-3" />

      <PopupButton :placement="'bottom-end'" :offset="3">
        <template #button>
          <div class="tooltip" data-tip="List filters">
            <div class="tour-config-filters btn btn-ghost text-xl">
              <Icon icon="ic:outline-filter-alt" />
            </div>
          </div>
        </template>
        <template #popup>
          <ConfigListFilters class="p-4" />
        </template>
      </PopupButton>

      <ConfigUpdateButton class="tour-config-save" />

      <button
        class="tour-config-details btn btn-neutral"
        @click="showDetails = !showDetails"
      >
        More
      </button>
    </div>

    <VueFinalModal
      class="flex justify-center items-center"
      content-class="tour-config-edit modal-box w-full md:max-w-3xl sm:overflow-visible"
      @update:modelValue="(v) => (showDetails = v)"
      :modelValue="showDetails || help.configDetailsExpand"
      :hide-overlay="false"
    >
      <h1 class="font-semibold text-lg">Keyboard configuration</h1>

      <ConfigEdit class="tour-config-edit p-4" />
    </VueFinalModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useHelpStore } from "@/stores";
import { VueFinalModal } from "vue-final-modal";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConfigList from "@/components/config/ConfigList.vue";
import ConfigListFilters from "@/components/config/ConfigListFilters.vue";
import ConfigEdit from "@/components/config/ConfigEdit.vue";
import ConfigWarnings from "@/components/config/ConfigWarnings.vue";
import ConfigModifiedIndicator from "@/components/config/ConfigModifiedIndicator.vue";
import ConfigUpdateButton from "@/components/config/ConfigUpdateButton.vue";

const help = useHelpStore();

const showDetails = ref(false);
</script>
